import o from "../toDate/index.js";
import a from "../_lib/requiredArgs/index.js";
function u(t) {
  a(1, arguments);
  var r = o(t), e = r.getMonth();
  return e;
}
export {
  u as default
};
//# sourceMappingURL=index.js.map
